import Loading from 'frontend/components/reports/curriculum/loading';
<template><Loading /></template>
